export const GET_USERS_LIST_BY_TYPE = 'GET_USERS_LIST_BY_TYPE';
export const REGISTER_USERS_BY_TYPE = 'REGISTER_USERS_BY_TYPE';
export const UPDATE_STATUS = 'UPDATE_STATUS';
export const UPDATE_STATUS_COGNITO = 'UPDATE_STATUS_COGNITO';
export const VERIFY_USERS = 'VERIFY_USERS';
export const USER_SUCCESS = 'USER_SUCCESS';
export const USER_ERROR = 'USER_ERROR';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAIL = 'UPDATE_USER_FAIL';